import { render, staticRenderFns } from "./GetUserName.vue?vue&type=template&id=6ad96292&"
import script from "./GetUserName.vue?vue&type=script&lang=ts&"
export * from "./GetUserName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports